module.exports = __webpack_public_path__ + "img/form-cta-bg.0ae1917c.jpg";